<select
  class="rounded border border-slate-300 bg-white px-3 py-1 text-sm text-slate-900 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
  [value]="value"
  (change)="onChange($event)">
  <option *ngFor="let option of options" [value]="option.code">
    {{ option.label }}
  </option>
</select>
